const constants = {
    SET_SOLID_RATE_VALUES: "SET_SOLID_RATE_VALUES",
    SET_ATOMIC_MASS_VALUES: "SET_ATOMIC_MASS_VALUES",
    SET_DENSITY_CORRECTION_VALUES: "SET_DENSITY_CORRECTION_VALUES",
    SET_UNIT_CONVERTER_VALUES: "SET_UNIT_CPNVERTER_VALUES",
    SET_PROCESS_YIELD_VALUES: "SET_PROCESS_YIELD_VALUES",
    SET_SO3_CORRECTION_VALUES: "SET_SO3_CORRECTION_VALUES",
    SET_PROPERTY_TABLE_VALUES: "SET_PROPERTY_TABLE_VALUES",
    CLEAR_PROPERTY_TABLE_VALUES: "CLEAR_PROPERTY_TABLE_VALUES",
    SET_NEWS: "SET_NEWS",
    SET_FILES: "SET_FILES"
}
export default constants